import {
    IQueryContext,
    IQueryContextDatasourceColumn,
} from 'src/app/services/query-context/models/IQueryContext';
import {
    ICompiledSQLTokens,
    IDatasourceSQLMap,
    mergeSqlTokensArray,
} from 'src/app/utils/datasource-sql-map/datasource';
import { multipleSelectComponentCompileSQLTokens } from 'src/app/utils/datasource-sql-map/utils';
import { GcpProjectId } from 'src/app/utils/gcp-project-id.model';
import { buildSplitGroupSQL, buildWhereSQL } from 'src/app/utils/query/sql';

export class BiVizDashboardMasterCampaignKpisDailySqlMap {
    public static sqlMap: IDatasourceSQLMap = {
        dataset: 'bi_viz',
        tableId: 'dashboard_master_campaign_kpis_daily',
        columns: {
            COMPANY_PROJECT_NAME: {
                columnId: 'COMPANY_PROJECT_NAME',
                columnSQL: 'project_name',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'project_name',
                        state
                    );
                },
            },
            FIRST_GEO_COUNTRY_TIER: {
                columnId: 'FIRST_GEO_COUNTRY_TIER',
                columnSQL: 'country_tier_label',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'country_tier_label',
                        state
                    );
                },
            },
            FIRST_GEO_COUNTRY: {
                columnId: 'FIRST_GEO_COUNTRY',
                columnSQL: 'unified_country',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'unified_country',
                        state
                    );
                },
            },
            // FIRST_ATTRIBUTION_UNIFIED_CAMPAIGN: {
            //     columnId: 'FIRST_ATTRIBUTION_UNIFIED_CAMPAIGN',
            //     columnSQL: 'campaign_name',
            //     compileSQLTokens: (state) => {
            //         return multipleSelectComponentCompileSQLTokens(
            //             'campaign_name',
            //             state
            //         );
            //     },
            // },
            // FIRST_ATTRIBUTION_UNIFIED_TRAFFIC: {
            //     columnId: 'FIRST_ATTRIBUTION_UNIFIED_TRAFFIC',
            //     columnSQL: 'network_name',
            //     compileSQLTokens: (state) => {
            //         return multipleSelectComponentCompileSQLTokens(
            //             'network_name',
            //             state
            //         );
            //     },
            // },
        },
    };

    public static compileSQLStatements(
        supportedDatasourceColumns: IQueryContextDatasourceColumn[],
        queryContextSettings: IQueryContext['settings'],
        options: { gcpProjectId: GcpProjectId },
        customCompiledSqlTokens?: Partial<ICompiledSQLTokens>
    ) {
        const dateTrunc = queryContextSettings.dateAggregation
            ? `DATE_TRUNC(date, ${queryContextSettings.dateAggregation})`
            : `date`;

        const sqlTokensArray: Partial<ICompiledSQLTokens>[] =
            supportedDatasourceColumns.map((dsCol) => {
                return this.sqlMap.columns[dsCol.id]!.compileSQLTokens!(
                    dsCol.state,
                    options
                );
            });
        // merge tokens into single deduplicated object of type ICompiledSQLTokens
        const sqlTokens: ICompiledSQLTokens =
            mergeSqlTokensArray(sqlTokensArray);

        const splitSelect: string = buildSplitGroupSQL(sqlTokens.split_group);
        const splitGroupBy = splitSelect ? 'split_group, ' : '';
        const where: string = buildWhereSQL([
            ...sqlTokens.where,
            ...(customCompiledSqlTokens?.where ?? []),
        ]);

        const windowTotal = splitGroupBy ? 'PARTITION BY split_group' : '';
        const windowRunning = splitGroupBy
            ? 'PARTITION BY split_group ORDER BY day_no'
            : 'ORDER BY day_no';

        return {
            dateTrunc,
            splitSelect,
            splitGroupBy,
            where,
            windowTotal,
            windowRunning,
        };
    }
}
